import { Component } from '@angular/core';
@Component({
  selector: 'loading',
  template: '<i icon="loading"></i>',
})
export class LoadingComponent {}
